 export const messages = {
   page_hints: {
        commonSavedMsg: "Saved successfully",
        commonUpdatedMsg: "Updated successfully",
        commonSaveFailedMsg: "Failed to save",
        commonUpdateFailedMsg: "Failed to update",
        CommonUpdateNew:"Please click <b>Yes</b> to Update the transaction or <b>No</b> to remain on the current page",
        CommonSave: "Please click Yes to save the transaction or No to remain on the current page",
        CommonSaveNew:"Please click <b>Yes</b> to save the transaction or <b>No</b> to remain on the current page",
        UniqueIdgenerator: "To generate the UHID for the patient this set up must be configured",
        Printersettings:"The print page settings for the bills under each module can be set up here",
        Unit:"The unit measurement for medicines or patient food intake has to be set up here",
        Mandatorysettings:"The mandatory field settings i.e., the mandatory fields for the registration page, IP admission page and doctor registration page can be set up here",
        OPDSequencegenerator:"This set up needs to be configured to generate the token number for the patients",
        OPDmonitorsetup:"The monitor set up for each doctor or each department can be set up here",
        Usertype:"The different users from different departments who use the HMS can be added here",
        Department:"The various departments inside the hospital can be uploaded here",
        ShiftTimes:"The shift times when the doctors and the nurses enter can be set up here",
        Designations:"The different designations of the user under all the departments have to be uploaded in this page",
        Service:"The general services and radiology services can be created here",
        ServiceCategory:"Enter the category of the services",
        ServiceSubCategory:"Enter the sub category of the services",
        LabTest:"The lab tests can be created here",
        LabGroup:"The lab group tests can be created here",
        LabPackage:"The Lab Packages can be created here",
        GeneralPackage:"The packages including, lab tests, radiology services and general services can be added here",
        PriceSettings:"Ward wise price settings can be allocated here",
        Doctor:"To enter the details of the doctors in the hospital, fill in the following details",
        Employees:"Add the employee in the hospital by adding their details",
        Referrals:"Add the referrals and referral details",
        VisitMode:"To log in the visit modes",
        Camp:"Enter the camp details",
        CampPatientList:"Enter the details of the patient who were registered during the camp",
        PackageType:"The type of the package which will be linked with Services->General Package",
        PackageValidity:"The validity of the General pacakge",
        Payer:"To enter the payer details of the patient",
        Bank:"To enter the bank details of the hospital",
        Ambulance:"To Enter the vehicle details of the hospital",
        Ledger:"To add the ledger options in the hospital",
        AccountsGroup:"To enter the accounts group options",
        DoctorRevenueShareConfig:"To configure the doctor revenue for services",
        SocialHabits:"To enter the social habits",
        Allergy:"To enter and log the various allergies",
        MedicalHistory:"To enter the medical history present for the patients",
        ChiefComplaints:"To log the chief complaints",
        Examination:"To log in the various examination present",
        TrainingClass:"To log in the training classes present inside the hospital",
        Instruction:"To add the instructions for the patients",
        Diagnosis:"To add the basic Diagnosis present",
        FavoritePrescription:"To log the frequently prescribed medicine combinations under favorites",
        PrescriptionSettings:"To set the prescription options according to the doctor",
        DentalProcedure:"To add the various dental procedures present",
        DentalProblem:"To enter the various dental problems present",
        TreatmentPlan:"To log in the various treatment plans present",
        ComboVaccine:"To add the combo vaccines,Search the medicine name and the vaccine name and click on save",
        Store:"To log in the pharmacy store of the hospital",
        Supplier:"To log in the supplier details, who provide the medicinal requirements for the hospital",
        StorageShelf:"To enter the storage shelves present in the pharmacy",
        Medicine:"To login the medicines present in the hospital",
        Customer:"To add the regular customers of the pharmacy",
        PharmacyLocation:"To add the various pharmacy location details",
        CaseSheetTemplateMaster:"To add case sheet template details",
        // Pharmacy Dashboard
        Checklist:"To add the checklist for the OT under the OT Schedule- Surgery Team",
        CSSD:"To add the CSSD items needed for the OT",
        Count:"To add the counts needed for the OT",
        Implant:"To add the Implants in the list",
        Surgery:"To add the surgeries present in the hospital",
        Table:"To log in the table details present in the hospital",
        OTCancelReason:"To enter the reasons to cancel the operation",
        MedicinePackage:"To enter the medicine package for the Operation",
        KeyroleVsService:"To enter the role and services of the employees for the Operation",
        BarcodeTemplate:"To set the bar code template for the lab tests",
        LabTestMethod:"To enter the lab test methods",
        LabTestMaterial:"To enter the lab test materials",
        OutsideLab:"To enter the lab names which the hospital would recommend",
        LEM:"To enter the machine details in the lab",
        AdmissionType:"To log in the admission types or Admission Reasons",
        DientPlan:"To log in the diet plans for the in-patients",
        DischargeType:"To log in the discharge reasons of the patient",
        Ward:"To log in the ward details",
        Building:"To log in the building names or Block names present in the hospital",
        Floor:"To log in the floor details of the buildings",
        Room:"To log in the room details present in the hospital",
        Bed:"To log in the bed details which are present in the hospital",
        BedView:"To view the available and admitted beds",
        NursingCounter:"To log in the nursing counter details on each floor",
        ItemCategory:"To enter the different categories of inventory items and OT Items",
        ItemSubCategory:"To enter the different sub categories of inventory items and OT Items",
        ItemManufacturer:"To enter the different manufacturers of inventory items",
        Item:"To add the Inventory items and OT Items",
        Warehouse:"To add the warehouse details of the item",
        QCReason:"To add the reasons for Quality control",
        ScrapReason:"To add the reasons to dispose the item in the scrap",
        CreditNoteReason:"To add the reasons to enter a credit note",
        DebitNoteReason:"To add the reasons to enter a debit note",
        InternalDepartment:"To add the various Internal departments present in the hospital",
        Vehicle:"To add the vehicles present in the hospital",
        Carrier:"To add the carrier and their details",
        AssetType:"Enter the name of the asset",
        AssetSubType:"Enter the type of the asset",
        AssetMaster:"Enter the Asset",
        ContentManagement:"The content for sending SMS for the patients will be managed here",
        SMSGatewayConfiguration:"To Configure the SMS Gateway",
        ComponentType:"To log the component type of the blood",
        BagType:"To log the bag type to fill the blood",
        DonationType:"To log the donation type",
        DonorType:"To log the donor type",
        BloodBank:"To add the blood banks and their details",
        CampUpload:"To upload the camp patient details into the system",
        CRMProductMaster:"To enter the CRM product details and description",
        CRMAdvertisementCategoryMaster:"To enter the Advertisement Category names",
        CRMAdvertisementSubCategoryMaster:"To enter the Advertisement Sub-Category names",
        CRMEnquiryStatusMaster:"To enter the enquiry status",
        CRMSalesQuoteStatusMaster:"To enter the sales quote status",
        TermsandConditionMaster:"To enter the Terms and Conditions for the Products",
        SurgerySubCategory:"To enter the sub Category for the service",
        Location:"To add the location details in the hospital",
        Packagehint:"This filter is not applicable for the Lab Package.",
	AssignedBranchPhysician:"Select the branches where this physician is available. Physician details will be loaded for appointment booking and billing based on these assigned branches.If All is selected, the physician will be available in all branches by default",
        admissionList:"Choose Ward/Nursing Counter to view Available beds"
    }


}
